<template>
  <div>
    <header class="d-flex mb-4">
      <div class="p-3 bg-secondary-light">
        <a href="/"
          ><img
            width="170"
            alt="Perivoli Schools logo"
            src="../../public/img/perivolischoolstrust-logo.png"
        /></a>
      </div>
      <div class="flex-fill">
        <b-navbar
          toggleable="md"
          tag="nav"
          type="dark"
          class="bg-secondary-mid"
        >
          <b-navbar-toggle target="navbarIntro" class="my-1"></b-navbar-toggle>
          <b-collapse is-nav id="navbarIntro">
            <div class="mr-auto text-secondary-light pl-2">
              <strong>PerivoliDB</strong>
            </div>
            <!-- if not logged in, show login form: -->
            <b-form inline id="LoginForm" v-show="!isLoggedIn">
              <label class="sr-only" for="LoginFormEmail">your email</label>
              <b-form-input
                class="mr-sm-2 email-form"
                v-show="!isLoggedIn"
                placeholder="your email"
                v-model="email"
                autocomplete="on"
                type="email"
                v-validate="'required|email'"
                name="email"
                id="LoginFormEmail"
                aria-describedby="email-help-block"
                :class="{ input: true, 'is-danger': errors.has('email') }"
              ></b-form-input>
              <b-form-text
                id="email-help-block"
                v-if="errors.has('email')"
                class="help is-danger"
                >{{ errors.first("email") }}</b-form-text
              >
              <label class="sr-only" for="LoginFormPassword"
                >your password</label
              >
              <b-form-input
                class="mr-sm-2"
                placeholder="your password"
                v-model="password"
                autocomplete="off"
                type="password"
                name="password"
                id="LoginFormPassword"
              ></b-form-input>
              <div>
                <b-button
                  type="submit"
                  variant="secondary"
                  @click.prevent="handleLogin"
                  v-if="!loggingIn"
                  >Log in</b-button
                >
                <b-spinner v-else></b-spinner>
              </div>
            </b-form>
            <!-- else if logged in, just show signout button: -->
            <b-button
              size="md"
              @click.prevent="handleLogout"
              v-show="isLoggedIn"
              class="my-2 my-md-0 warning"
              >Signout</b-button
            >
          </b-collapse>
        </b-navbar>

        <b-navbar toggleable="md" tag="nav" type="dark" class="bg-secondary">
          <b-navbar-toggle target="navbarMenu" class="my-1"></b-navbar-toggle>
          <b-collapse id="navbarMenu" is-nav>
            <b-navbar-nav class="mr-auto">
              <b-nav-item-dropdown id="dashboards" text="MIOs" v-if="isAdmin || isSRC">
                <b-dropdown-item to="/mio/annual-interactions">Annual & Cumulative Interactions</b-dropdown-item>
                <b-dropdown-item to="/mio/class-visits">Class Visits</b-dropdown-item>
                <b-dropdown-item to="/mio/parent-certificates">Parent Certificates</b-dropdown-item>
                <b-dropdown-item to="/mio/trainer-teams">Trainer Teams</b-dropdown-item>
                <b-dropdown-item to="/mio/location-performance">Location Performance</b-dropdown-item>
                <b-dropdown-item to="/mio/schools-map">Map</b-dropdown-item>
                <b-dropdown-item to="/mio/trainer-coordinator-performance"
                  >Trainer / Coordinator Performance</b-dropdown-item
                >
                <b-dropdown-item to="/mio/remuneration-reconciliation"
                  >Remuneration Reconciliation</b-dropdown-item
                >
                <b-dropdown-item to="/mio/classroom-attainment"
                  >Classroom Attainment</b-dropdown-item
                >
                <b-dropdown-item to="/mio/covid-observations"
                  >COVID Observations</b-dropdown-item
                >
                <b-dropdown-item to="/mio/consent"
                  >Data Consent</b-dropdown-item
                >
              </b-nav-item-dropdown>
              <b-nav-item-dropdown id="pd-pages" class="dropdown-list" text="CEO Pages" v-if="isAdmin">
                <b-dropdown-item to="/pd/ceo-bonuses">CEO Bonuses</b-dropdown-item>
                <b-dropdown-item to="/pd/rc-performance">RC Performance</b-dropdown-item>
              </b-nav-item-dropdown>
              <b-nav-item-dropdown id="cd-pages" class="dropdown-list" text="CD Pages"  v-if="isAdmin">
                <b-dropdown-item to="/cd/country-activity">Country Activity</b-dropdown-item>
                <b-dropdown-item to="/rc/bonus-calculation">RC Bonus Calculation</b-dropdown-item>
              </b-nav-item-dropdown>
              <b-nav-item-dropdown id="cd-pages" class="dropdown-list" text="SRC Pages"  v-if="isSRC">
                <b-dropdown-item to="/src/country-activity">Country Activity</b-dropdown-item>
                <b-dropdown-item to="/src/bonus-calculation">RC Bonus Calculation</b-dropdown-item>
              </b-nav-item-dropdown>
              <b-nav-item-dropdown
                id="rc-pages"
                class="dropdown-list"
                text="RC Pages"
                v-if="isAdmin || getCoordinatorUuid || isSRC"
              >
                <b-dropdown-item to="/rc/summary">Summary</b-dropdown-item>
                <b-dropdown-item to="/rc/trainer-activity">Trainer Activity</b-dropdown-item>
                <b-dropdown-item to="/rc/bonus-calculation">Bonus Calculation</b-dropdown-item>
              </b-nav-item-dropdown>

              <b-nav-item-dropdown
                id="dashboards"
                class="dropdown-list"
                text="Dashboards"
                v-if="false"
              >
                <b-dropdown-item to="/data/headline-data"
                  >Headline Data</b-dropdown-item
                >
                <b-dropdown-item to="/data/groups">Groups</b-dropdown-item>
                <b-dropdown-item to="/data/trainers">Trainers</b-dropdown-item>
                <b-dropdown-item to="/data/schools">Schools</b-dropdown-item>
                <b-dropdown-item to="/data/teachers">Teachers</b-dropdown-item>
                <b-dropdown-item to="/data/students">Students</b-dropdown-item>
              </b-nav-item-dropdown>
              <b-nav-item-dropdown
                id="add-data"
                class="dropdown-list"
                text="Add Data"
              >
                <b-dropdown-item to="/users/add" v-if="isAdmin"
                  >Add an Admin User</b-dropdown-item
                >
                 <b-dropdown-item to="/src/add" v-if="isAdmin"
                  >Add a SRC</b-dropdown-item
                >
                <b-dropdown-item :to="{ name: 'NewCoordinator' }" v-if="isAdmin"
                  >Add a Coordinator</b-dropdown-item
                >
                <b-dropdown-item to="/teams/add" v-if="isAdmin || isSRC"
                  >Add a Team</b-dropdown-item
                >
                <b-dropdown-item to="/groups/add" v-if="isAdmin || isSRC"
                  >Add a Group</b-dropdown-item
                >
                <b-dropdown-item to="/trainers/add" v-if="isAdmin || isSRC"
                  >Add a Trainer</b-dropdown-item
                >
                <b-dropdown-item to="/schools/add" v-if="isAdmin || isSRC"
                  >Add a School</b-dropdown-item
                >
                <b-dropdown-item to="/teachers/add" v-if="isAdmin || isSRC"
                  >Add a Teacher</b-dropdown-item
                >
                <b-dropdown-item to="/students/add" v-if="isAdmin || isSRC"
                  >Add a Student</b-dropdown-item
                >
                <b-dropdown-item to="/class/add" v-if="isAdmin || isSRC"
                  >Add a Class</b-dropdown-item
                >
              </b-nav-item-dropdown>
              <b-nav-item-dropdown
                id="view-edit"
                class="dropdown-list"
                text="View/Edit Data"
              >
                <b-dropdown-item to="/edit-options" v-if="isAdmin"
                  >Edit List Options</b-dropdown-item
                >
                <b-dropdown-item to="/users/admin" v-if="isAdmin"
                  >All Admin</b-dropdown-item
                >
                <b-dropdown-item to="/user/list/src" v-if="isAdmin"
                  >All SRC's</b-dropdown-item
                >
                <b-dropdown-item to="/coordinators" v-if="isAdmin || isSRC"
                  >All Coordinators</b-dropdown-item
                >
                <b-dropdown-item to="/teams" v-if="isAdmin || isSRC"
                  >All Teams</b-dropdown-item
                >
                <b-dropdown-item to="/trainers" v-if="isAdmin || isSRC"
                  >All Trainers</b-dropdown-item
                >
                <div v-if="isSRC == false && isAdmin == false">
                  <b-dropdown-item :to="myProfile"
                    >My Profile</b-dropdown-item
                  >
                </div>
                <b-dropdown-item to="/groups" v-if="isLoggedIn"
                  >All Groups</b-dropdown-item
                >
                <b-dropdown-item to="/schools" v-if="isLoggedIn"
                  >All Schools</b-dropdown-item
                >
                <b-dropdown-item to="/teachers" v-if="isLoggedIn"
                  >All Teachers</b-dropdown-item
                >
                <b-dropdown-item to="/class" v-if="isLoggedIn"
                  >All Classes</b-dropdown-item
                >
                <b-dropdown-item to="/students" v-if="isLoggedIn"
                  >All Students</b-dropdown-item
                >
                <b-dropdown-item to="/school-location" v-if="isLoggedIn"
                  >School Locations</b-dropdown-item
                >
              </b-nav-item-dropdown>
              <b-nav-item-dropdown
                v-if="isNolly"
                id="me"
                class="dropdown-list"
                text="M+E"
              >
                <b-dropdown-item to="/primary-schools" v-if="isAdmin || isSRC"
                  >Primary Schools</b-dropdown-item
                >
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </header>
    <b-container>
      <b-alert
        :show="dismissSignIn"
        dismissible
        variant="success"
        @dismissed="dismissSignIn = 0"
        @dismiss-count-down="countDownChanged"
        id="signinFlash"
      >
        You have successfully signed in. Use the headings above to navigate the
        database.
      </b-alert>
      <b-alert
        :show="dismissSignOut"
        dismissible
        variant="warning"
        @dismissed="dismissSignOut = 0"
        @dismiss-count-down="countDownChanged"
        id="signoutFlash"
        >You have successfully signed out. Login to see data.</b-alert
      >
      <b-alert
        :show="dismissError"
        dismissible
        variant="danger"
        @dismissed="dismissError = 0"
        @dismiss-count-down="countDownChanged"
        id="errorFlash"
        >There was a problem signing in. Please try again.</b-alert
      >
      <b-alert
        :show="dismissAuthFlash"
        dismissible
        variant="danger"
        @dismissed="dismissAuthFlash = 0"
        @dismiss-count-down="countDownChanged"
        id="authFlash"
        >You need to be signed in to access this page.</b-alert
      >
      <b-alert
        :show="dismissAdminFlash"
        dismissible
        variant="danger"
        @dismissed="dismissAdminFlash = 0"
        @dismiss-count-down="countDownChanged"
        id="adminFlash"
        >You need to be a site administrator to access this page.</b-alert
      >
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions, mapGetters } from "vuex";
import AuthService from "@/services/AuthService";

export default {
  name: "MenuBar",
  data() {
    return {
      dismissSecs: 5,
      dismissCountDown: 0,
      dismissSignIn: 0,
      dismissError: 0,
      dismissSignOut: 0,
      dismissAuthFlash: 0,
      dismissAdminFlash: 0,
      email: "",
      password: "",
      loggingIn: false
    };
  },
  methods: {
    ...mapActions({
      LOGIN: "auth/LOGIN",
      LOGOUT: "auth/LOGOUT",
      REGISTER: "auth/REGISTER",
      REQUIRES_AUTH: "auth/REQUIRES_AUTH",
      REQUIRES_ADMIN: "auth/REQUIRES_ADMIN"
    }),
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    flashSignOut() {
      this.dismissSignOut = this.dismissSecs;
    },
    flashSignIn() {
      this.dismissSignIn = this.dismissSecs;
    },
    flashError() {
      this.dismissError = this.dismissSecs;
    },
    flashAuth() {
      this.dismissAuthFlash = this.dismissSecs;
    },
    flashAdmin() {
      this.dismissAdminFlash = this.dismissSecs;
    },
    resetLoginFields() {
      this.email = "";
      this.password = "";
    },
    async handleLogin() {
      this.loggingIn = true;
      const credentials = {
        email: this.email.toLowerCase(),
        password: this.password
      };
      try {
        await this.LOGIN(credentials).then(async () => {
          await this.flashSignIn();
          this.resetLoginFields();
          this.loggingIn = false;
        });
      } catch (err) {
        this.flashError();
        console.error(err);
        this.resetLoginFields();
        this.loggingIn = false;
      }
    },
    async handleLogout() {
      try {
        this.LOGOUT();
        this.$router.push({ name: "Home" });
        await this.flashSignOut();
      } catch (err) {
        await this.flashError();
        console.error(err);
      }
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "auth/isLoggedIn",
      requiresAdmin: "auth/requiresAdmin",
      requiresAuth: "auth/requiresAuth",
      isAdmin: "auth/isAdmin",
      isSRC: "auth/isSRC",
      getTrainerUuid: "auth/getTrainerUuid",
      getCoordinatorUuid: "auth/getCoordinatorUuid"
    }),
    isNolly() {
      return this.$store.state.auth.user.user_name === "Noelle Molton";
    },
    myProfile() {
      // console.log("getCoordinatorUUID: ", this.getCoordinatorUuid);
      // console.log("getTrainerUUID: ", this.getTrainerUuid);
      if (
        this.getCoordinatorUuid != null &&
        this.getCoordinatorUuid.length > 0
      ) {
        return {
          name: "EditCoordinator",
          params: { id: this.getCoordinatorUuid }
        };
      } else {
        return {
          name: "EditTrainer",
          params: { id: this.getTrainerUuid }
        };
      }
    }
  },
  watch: {
    requiresAdmin(val) {
      if (val === true) {
        this.flashAdmin();
        // setTimeout(() => {
        this.REQUIRES_ADMIN();
        // }, 5000);
      }
    },
    requiresAuth(val) {
      if (val === true) {
        this.flashAuth();
        // setTimeout(() => {
        this.REQUIRES_AUTH();
        // }, 5000);
      }
    }
  },
  created(){
    // const local = JSON.parse(localStorage.getItem("userLogin"));
    // console.log(local.admin);
  }
};
</script>
